// extracted by mini-css-extract-plugin
export default {"userInfo":"_INHfUgamjRRdMaW9RoE","check":"EUZxNLYbqL18yQ4UKFUU"};